import { resolvePageContent, resolveAdminPageContent, resolvePageList, resolveEmailPageList, resolveAdminPageList } from './resolvers/pageContent.resolver';

export default [ '$stateProvider', $stateProvider => {
  $stateProvider
    .state('app.admin.pageContent', {
      url: '/page-content',
      component: 'pageContentList',
      resolve: {
        pages: resolvePageList()
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.emailPageContent', {
      url: '/email-content',
      component: 'pageContentList',
      resolve: {
        pages: resolveEmailPageList(),
        type : () => 'email'
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.globalPageContent', {
      url: '/admin-page-content',
      component: 'pageContentList',
      resolve: {
        pages: resolveAdminPageList(),
        type : () => 'global'
      },
      roles: [ 'admin' ]
    })
    .state('app.admin.pageContent-edit', {
      url: '/page-content/:page',
      component: 'pageContentSave',
      resolve: {
        title: () => 'Update a Page',
        page: resolvePageContent()
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.emailPageContent-edit', {
      url: '/email-content/:page',
      component: 'pageContentSave',
      resolve: {
        title: () => 'Update Email Content',
        page: resolvePageContent(),
        type: () => 'email'
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.globalPageContent-edit', {
      url: '/admin-page-content/:page',
      component: 'pageContentSave',
      resolve: {
        title: () => 'Update a Page',
        page: resolveAdminPageContent(),
        type : () => 'admin'
      },
      roles: [ 'admin' ]
    })
    ;
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/pageContent.routes.js